import type { PageResponse } from './common'

export type PurchaseOrderStatus =
  | 'CREATED'
  | 'APPROVED'
  | 'ORDERED'
  | 'IN_TRANSIT'
  | 'PARTIALLY_RECEIVED'
  | 'RECEIVED'
  | 'CANCELLED'
  | 'CLOSED'

export interface PurchaseOrderItem {
  id: number
  skuCode: string
  partName: string
  specification?: string
  quantity: number
  receivedQty: number
  unit: string
  unitPrice?: number | null
}

export interface PurchaseOrder {
  id: number
  purchaseNo: string
  workOrderNo?: string | null
  status: PurchaseOrderStatus
  supplierName: string
  expectedDeliveryDate?: string | null
  warehouseCode?: string | null
  trackingNo?: string
  remark?: string
  items: PurchaseOrderItem[]
  createdAt: string
}

export interface CreatePurchaseOrderRequest {
  workOrderId?: number
  supplierId?: number
  supplierName?: string
  expectedDeliveryDate?: string
  warehouseCode?: string
  remark?: string
  items: CreatePurchaseOrderItemRequest[]
}

export interface CreatePurchaseOrderItemRequest {
  skuCode: string
  partName: string
  specification?: string
  quantity: number
  unit: string
}

export interface ShipRequest {
  trackingNo: string
}

export interface ReceiveItemRequest {
  skuCode: string
  receivedQty: number
}

export interface ReceiveRequest {
  warehouseCode: string
  items: ReceiveItemRequest[]
}

export interface PurchaseOrderPageParams {
  status?: string
  keyword?: string
  page?: number
  size?: number
}

export type PurchaseOrderPageResponse = PageResponse<PurchaseOrder>

export const PURCHASE_STATUS_LABELS: Record<PurchaseOrderStatus, string> = {
  CREATED: '已创建',
  APPROVED: '已审批',
  ORDERED: '已下单',
  IN_TRANSIT: '运输中',
  PARTIALLY_RECEIVED: '部分到货',
  RECEIVED: '已到货',
  CANCELLED: '已取消',
  CLOSED: '已关闭',
}

export const PURCHASE_STATUS_COLORS: Record<PurchaseOrderStatus, string> = {
  CREATED: 'gray',
  APPROVED: 'blue',
  ORDERED: 'cyan',
  IN_TRANSIT: 'purple',
  PARTIALLY_RECEIVED: 'orange',
  RECEIVED: 'green',
  CANCELLED: 'red',
  CLOSED: 'gray',
}
